Ext.define('SA.view.sidebar.data.NoResultsMessage', {
    alias: 'widget.no-results-message',
    extend: 'Ext.Component',

    baseCls: 'sa-no-results-message',

    tpl: [
        '<svg class="sa-no-results-message-svg"><use href="#sa-icon-warning"></use></svg>',
        '<div class="sa-no-results-message-text">{text}</div>'
    ],

    initComponent() {
        this.update({text: this.text});

        this.callParent();
    }
});